var map = {
	"./act": 1521,
	"./act.ts": 1521,
	"./gmat": 1522,
	"./gmat.ts": 1522,
	"./gre": 1523,
	"./gre.ts": 1523,
	"./ielts": 1524,
	"./ielts.ts": 1524,
	"./ielts_general_training": 1525,
	"./ielts_general_training.ts": 1525,
	"./lsat": 1526,
	"./lsat.ts": 1526,
	"./mcat": 1527,
	"./mcat.ts": 1527,
	"./sat": 1528,
	"./sat.ts": 1528,
	"./toefl": 1529,
	"./toefl.ts": 1529
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2532;
module.exports = webpackAsyncContext;